// extracted by mini-css-extract-plugin
export var chevron = "_3c-2";
export var chevronCollapsed = "_3c-3";
export var collapsibleHeader = "_3c-1";
export var container = "_3c-0";